// extracted by mini-css-extract-plugin
export default {"wrap":"articlesContainer_wrap__L5JRn","innerContainer":"articlesContainer_innerContainer__yA7+j"};